export const Terms = {
  privacy:
    "https://intercom.help/innovationlabs/en/articles/16908954-smartli-s-privacy-policy",
  terms:
    "https://intercom.help/innovationlabs/en/articles/16908933-smartli-s-terms-of-service",
  refund:
    "https://intercom.help/innovationlabs/en/articles/16908916-what-is-smartli-s-refund-policy",
};
